export default "__VITE_ASSET__CdSP$7PQ__"